module.exports = __webpack_public_path__ + "static/img/welcome.1309f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/welcome.png
// module id = CD6D
// module chunks = 1